import React from 'react';
import { SolarType } from '../CommonTypes';
import logo from '../assets/ps_symbol.svg';

export const SolarTimeLine = ({
  times,
  setSelectedSolar,
  solars,
  currentSolar,
}: {
  times: string[];
  setSelectedSolar: (solar: SolarType) => void;
  solars: SolarType[];
  currentSolar: SolarType;
}) => {
  // Number of intervals = times.length - 1

  const handleSliderChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = parseFloat(e.target.value);
    const index = Math.round(value);

    if (solars[index].id !== currentSolar.id) {
      setSelectedSolar(solars[index]);
    }
  };

  const handleSliderEnd = (e: React.MouseEvent<HTMLInputElement> | React.TouchEvent<HTMLInputElement>) => {
    const input = e.target as HTMLInputElement;
    input.value = String(Math.round(parseFloat(input.value)));
  };

  if (!currentSolar) {
    return (
      <section className="sec-loading">
        <div className="one">
          <img className="bottom-10 h-32 w-32" alt="logo" src={logo}></img>
        </div>
      </section>
    );
  }

  return (
    <>
      <div className="flex w-[81%] flex-col items-center px-2">
        {/* Top: Time labels */}
        <div className="relative flex w-full justify-between">
          {times.map((label, idx) => (
            <div key={idx} className="flex flex-col items-center">
              <span className="text-l text-white">{label}</span>
            </div>
          ))}
        </div>
      </div>
      <div className="flex w-3/4 flex-col items-center px-2">
        {/* Middle: Ticks & Dots */}
        <div className="relative mt-1 flex w-full items-center justify-between">
          {/* Vertical ticks */}
          {times.map((_, idx) => (
            <div key={idx} className="flex flex-col items-center">
              <div className="h-3 w-[3px] rounded-sm bg-white opacity-80" />
            </div>
          ))}
          {/* Dots between ticks (absolutely positioned) */}
          <div className="pointer-events-none absolute inset-x-1 top-1/2 flex h-2 items-center justify-between md:inset-x-2">
            {Array.from({ length: times.length - 1 }).map((_, i) => (
              <div key={i} className="flex flex-col items-center">
                <svg key={i} width="100%" height="6">
                  <line
                    x1="0"
                    y1="3"
                    x2="100%"
                    y2="3"
                    stroke="white"
                    strokeWidth="2"
                    strokeDasharray="1,8" // 2px dot, 8px gap
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="w-3/4">
        <input
          id="default-range"
          min="0"
          max={solars.length - 1}
          type="range"
          step="any"
          onChange={handleSliderChange}
          onMouseUp={handleSliderEnd}
          onTouchEnd={handleSliderEnd}
          className="mt-2 h-2 w-full cursor-pointer appearance-none rounded-lg bg-gray-200 accent-[#00965f] dark:bg-gray-700"
        />
      </div>
      <span className="mt-2 text-sm text-white">
        {currentSolar.date} <span className="ml-4"> {currentSolar.name}</span>
      </span>
    </>
  );
};
